import { NavigationRoutes } from "./routes";

const App = () => {
  return <NavigationRoutes />;
};

export default App;
